import type { SxProps, Theme } from "@mui/material/styles";

// Shared TextField sizing for the Module Builder. Drops input/label/helper
// text font sizes so user-entered fields read at the same scale as the
// surrounding body2/caption Typography in the workspace and rails. Use
// alongside `size="small"` on the TextField.
export const compactFieldSx: SxProps<Theme> = {
  "& .MuiInputBase-input": { fontSize: "0.85rem" },
  "& .MuiInputLabel-root": { fontSize: "0.85rem" },
  "& .MuiFormHelperText-root": { fontSize: "0.72rem" }
};
